import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IMergePolygonsFeature, IVertexGroup } from '../kb3d-models';
import { Token } from '../token';
import { ALL_GEOMETRY, Feature, eMeshChangeTypes } from './feature';

@Kb3dModel({
    token: Token.MergePolygonsFeature,
})
export class MergePolygonsFeature extends Feature implements IMergePolygonsFeature {
    static _dependsOn = new Set([eMeshChangeTypes.VertexIndices]);
    static _affects = new Set(ALL_GEOMETRY);
    static _affectedBy = new Set(ALL_GEOMETRY);

    vertexGroups: Array<Required<IVertexGroup>> = [];
}
